/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/metadata/dataTransfer/resolvers/default/link/document"/>
import * as pathLib from "Core/Medius.Core.Web/Scripts/Medius/lib/path";
import {unpack} from "Core/Medius.Core.Web/Scripts/Medius/knockout/utils";
import * as typeBoundResolverFactory from "Core/Medius.Core.Web/Scripts/Medius/core/metadata/dataTransfer/resolvers/typeBound";
import { getEmbeddableUrlIfNeeded } from "Core/Medius.Core.Web/Scripts/Bifrost/embedding";

export const resolver = typeBoundResolverFactory.create({
    priority: typeBoundResolverFactory.priority.lowest,
    type: "Medius.Data.Document",
    resolve: function (data: any) {
        const entityId = unpack(data.Id);
        const prefix = getEmbeddableUrlIfNeeded("#Tasks");

        return {
            link: pathLib.getBasePath() + [prefix, "ShowDocument", entityId].join("/")
        };
    }
});